<script setup lang="ts">
// Modal zapytania ofertowego montujemy tylko w sklepie katalogowym — lavmag i
// youlook nie mają go w drzewie w ogóle, więc nie płacą za niego niczym.
const { enabled: catalogOnly } = useCatalogOnly()
</script>

<template>
  <div class="site-shell">
    <SiteHeader />
    <main>
      <slot />
    </main>
    <CartDrawer />
    <SiteFooter />
    <!-- Popupy to kampanie promocyjne (kody rabatowe, wyprzedaże) — w sklepie
         bez koszyka nie ma gdzie zrealizować obietnicy. Na gadżetach wyskakiwał
         panel „TWOJE ZNIŻKI — Kody EXTRA" z uchwytem zasłaniającym hero. -->
    <PopupOverlay v-if="!catalogOnly" />
    <QuoteRequestModal v-if="catalogOnly" />
  </div>
</template>
